import styled from "@emotion/styled";

const Container = styled.div`
  width: 380px;
`;

export { Container };
